/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_Prize_DInputs */

const en_cp_ch_prize_d = /** @type {(inputs: Cp_Ch_Prize_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track winners: 6 months of Bystep credits for the team, a feature on this page, a 1:1 mentor session with a practitioner. Top 10: finalist certificate.`)
};

const id_cp_ch_prize_d = /** @type {(inputs: Cp_Ch_Prize_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara per jalur: kredit Bystep 6 bulan untuk tim, tampil di halaman ini, sesi mentor 1:1 dengan praktisi. 10 besar: sertifikat finalis.`)
};

/**
* | output |
* | --- |
* | "Track winners: 6 months of Bystep credits for the team, a feature on this page, a 1:1 mentor session with a practitioner. Top 10: finalist certificate." |
*
* @param {Cp_Ch_Prize_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_prize_d = /** @type {((inputs?: Cp_Ch_Prize_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_Prize_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_prize_d(inputs)
	return en_cp_ch_prize_d(inputs)
});